import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Plus } from 'lucide-react';
import { BACKEND_URL } from './backendConfig';
import GtmBin from './GtmBin';

/* THE PROJECT SKUs A PROGRAMME LAUNCHED — Max, 2026-10-08: "trong phiếu GTM sẽ có chỗ điền số
   project SKU nhé và sẽ hiện thị project SKU ID và tên. Đồng thời bên Project SKU cũng có thêm 1
   trường là GTM để điền nhé. Cái cơ chế nó sẽ tương tự như project SKU và sample tracker á" —
   Jihwan's point 4, "Connect approved proposals to the Project Tracker".

   THE SAME SHAPE AS A SAMPLE'S "Linked Project SKU", and STORED ONCE: this list is a query on
   `00_PORTAL_projects.gtm_code`, which is also what the SKU's own GTM field writes. The sample link
   is stored on both sides and synced, and 11 of its 443 rows already disagree; one column cannot.

   LINKING DOES NOT WAIT FOR APPROVAL — Max, 2026-10-08: "cho phép chọn project SKU luôn nhé". The
   first version drew no box until the programme was approved (Jihwan's "connect APPROVED
   proposals"); a programme is planned against its SKUs while it is being written, so it can be
   linked in any state, from either side. Unlinking likewise.

   Linking and unlinking happen on the press, like "Add a line" — they are their own rows, not
   fields on the sheet that the sheet's Save would write. */
const API = `${BACKEND_URL}/api/gtm`;

export default function GtmSkuLinks({ t, code, skus, may, onChanged, say }) {
  const [opts, setOpts] = useState(null);
  const [val, setVal] = useState('');
  const [busy, setBusy] = useState(false);
  const open = may;

  /* The choices are fetched the first time the box is drawn — an author reading the sheet has no
     use for 500 SKU ids, and the approver's grant does not reach this lookup at all. */
  useEffect(() => {
    if (!open || opts) return;
    fetch(`${API}/lookup/skus`, { credentials: 'include' })
      .then((r) => r.json()).then((j) => setOpts(j.rows || [])).catch(() => setOpts([]));
  }, [open, opts]);

  const call = async (url, method, body) => {
    setBusy(true);
    try {
      const r = await fetch(url, {
        method, credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: body === undefined ? undefined : JSON.stringify(body),
      });
      const j = await r.json().catch(() => ({}));
      if (!r.ok) throw new Error(j.error || `HTTP ${r.status}`);
      return true;
    } catch (e) { say(e.message, true); return false; }
    finally { setBusy(false); }
  };

  const add = async () => {
    if (!val.trim()) return;
    if (await call(`${API}/${encodeURIComponent(code)}/skus`, 'POST', { projectId: val.trim() })) {
      setVal('');
      setOpts(null);   // a SKU just moved under this programme; the hints in the box are stale
      await onChanged();
    }
  };
  const drop = async (id) => {
    if (await call(`${API}/${encodeURIComponent(code)}/skus/${encodeURIComponent(id)}`, 'DELETE')) {
      setOpts(null);
      await onChanged();
    }
  };

  return (
    <div className="gtm-sect gtm-skulinks">
      <h2>{t('gtm.skuHead')}</h2>
      <p className="hint">{t('gtm.skuHint')}</p>
      {skus.length ? (
        <div className="gtm-tablewrap">
          <table className="gtm-table gtm-skutable">
            <colgroup>
              <col style={{ width: 150 }} /><col /><col /><col style={{ width: 150 }} />
              {may && <col style={{ width: 56 }} />}
            </colgroup>
            <thead>
              <tr>
                <th>{t('gtm.skuId')}</th>
                <th>{t('gtm.skuName')}</th>
                <th>{t('gtm.skuGroup')}</th>
                <th>{t('gtm.skuStatus')}</th>
                {may && <th aria-label={t('gtm.colAction')} />}
              </tr>
            </thead>
            <tbody>
              {skus.map((s) => (
                <tr key={s.projectId}>
                  {/* The id opens the SKU in Project Tracker — the tracker's own ?project= search,
                      the one the approval mails and the home cards already use. */}
                  <td className="mono">
                    <Link to={`/development/sample-tracker?tab=project&project=${encodeURIComponent(s.projectId)}`}>
                      {s.projectId}
                    </Link>
                  </td>
                  <td>{s.itemName || '—'}</td>
                  <td>{s.groupId ? `${s.groupId}${s.groupName ? ` — ${s.groupName}` : ''}` : '—'}</td>
                  <td>{s.status || '—'}</td>
                  {may && (
                    <td className="gtm-rowdrop">
                      <GtmBin t={t} busy={busy} label={t('gtm.skuUnlink')} onRemove={() => drop(s.projectId)} />
                    </td>
                  )}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : <p className="gtm-items-none">{t('gtm.skuNone')}</p>}
      {open && (
        <div className="gtm-addline">
          <input
            list="gtm-sku-options" value={val} placeholder={t('gtm.skuPh')}
            onChange={(e) => setVal(e.target.value)}
            onKeyDown={(e) => { if (e.key === 'Enter') { e.preventDefault(); add(); } }}
          />
          <button type="button" className="gtm-btn" disabled={busy || !val.trim()} onClick={add}>
            <Plus size={13} /> {t('gtm.skuAdd')}
          </button>
          <datalist id="gtm-sku-options">
            {(opts || []).map((o) => (
              <option key={o.projectId} value={o.projectId}>
                {`${o.itemName}${o.groupName ? ` · ${o.groupName}` : ''}${o.gtmCode ? ` — ${o.gtmCode}` : ''}`}
              </option>
            ))}
          </datalist>
        </div>
      )}
    </div>
  );
}
